const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getBackendErrorCode = (error: unknown): string | undefined => {
  if (!isRecord(error)) {
    return undefined;
  }

  const errorCode = error.error_code;
  return typeof errorCode === "string" ? errorCode : undefined;
};

export const getBackendErrorMessage = (error: unknown): string | undefined => {
  if (!isRecord(error)) {
    return undefined;
  }

  const message = error.message;
  return typeof message === "string" ? message : undefined;
};

export const getBackendErrorFields = (error: unknown): Record<string, unknown> | undefined => {
  if (!isRecord(error) || !isRecord(error.errors)) {
    return undefined;
  }

  return error.errors;
};

export const getFirstBackendError = (error: unknown): unknown => {
  if (!isRecord(error) || !Array.isArray(error.errors)) {
    return error;
  }

  return error.errors[0];
};
